<!-- <table>
  <tr>
    <td>
      <strong>Título:</strong>
      FICHA DE TRIAGEM CLÍNICA PARA COLETA DE MATERIAL BIOLÓGICO
    </td>
  </tr>
  <tr>
    <td>
      Nome do Paciente: <strong>{{ doador.nome }}</strong>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        <span>Data nascimento: </span>
        <strong>{{ dataNascimentoDoador }}</strong>
        <span style="padding-left: 270px">CPF: </span>
        <strong>{{ doador.cpf }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Endereço: <strong>{{ doador.endereco }} </strong>, n°
        <strong>{{ doador.numEndereco }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        <span>CEP: </span> <strong>{{ doador.cep }}</strong>
        <span style="padding-left: 350px">Cidade: </span>
        <strong>{{ doador.cidade }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo" style="border-bottom: 0px">
        Sexo (&nbsp;<strong>{{ sexoFeminino(doador.sexo) }}</strong
        >&nbsp;) Feminino
        <span
          >(&nbsp;<strong>{{ sexoMasculino(doador.sexo) }}</strong
          >&nbsp;) Masculino
        </span>
        <span
          >(&nbsp;<strong>{{ sexoOutro(doador.sexo) }}</strong
          >&nbsp;) Outro
        </span>
      </p>
    </td>
  </tr>
</table>

<div class="space"></div>

<table>
  <tr>
    <td class="center-bottom-title" style="height: 40px">HISTÓRICO DE SAÚDE</td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">Está fazendo algum tratamento médico?</p>
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial1Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(this.coletor.historiaMedicaSocial1Flag)
      }}</strong
      >&nbsp;) não
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      <span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial1 }}</strong></span
      >
    </td>
  </tr>

  <tr>
    <td>
      <p class="page-paragrafo">
        Faz uso de algum medicamento? (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial2Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial2Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual(is) medicamento(s)?
          <strong>{{ this.coletor.historiaMedicaSocial2 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Possui algum tipo de alergia? (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial3Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial3Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual">Qual? </span>
        <strong [hidden]="!qual">{{
          this.coletor.historiaMedicaSocial3
        }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Faz algum tratamento complementar (fitoterápico, homeopático...)? <br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial4Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial4Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual">Qual? </span>
        <strong [hidden]="!qual">{{
          this.coletor.historiaMedicaSocial4
        }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Já realizou alguma intervenção cirúrgica?<br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial5Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial5Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual? <strong>{{ this.coletor.historiaMedicaSocial5 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Já recebeu transfusão de hemocomponentes ou fez uso de algum
        hemoderivado?<br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial6Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial6Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual? <strong>{{ this.coletor.historiaMedicaSocial6 }}</strong></span
        >
      </p>
    </td>
  </tr>

  <tr>
    <td>
      <p class="page-paragrafo">
        Já realizou algum transplante de células, tecidos ou órgãos ou
        xenotransplante (osso bovino, por exemplo)? <br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial7Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial7Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual? <strong>{{ this.coletor.historiaMedicaSocial7 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Possui alguma doença hereditária, hematológica ou imunológica? <br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial8Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial8Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual? <strong>{{ this.coletor.historiaMedicaSocial8 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Já teve algum tipo de doença maligna? (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial9Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial9Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual? <strong>{{ this.coletor.historiaMedicaSocial9 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Fez viagem recente e/ou teve exposição a agentes infecciosos? <br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial10Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial10Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Onde, qual, há quanto tempo?
          <strong>{{ this.coletor.historiaMedicaSocial10 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Teve contato com alguém confirmado ou suspeito de covid-19? <br />
        (&nbsp;<strong>{{
          opcaoSim(this.coletor.historiaMedicaSocial11Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          opcaoNao(coletor.historiaMedicaSocial11Flag)
        }}</strong
        >&nbsp;) não <br />
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Está ou teve algum destes sintomas: Febre, tosse, coriza, dor de
        garganta, dificuldade para respirar, perda de olfato, alteração do
        paladar, cansaço, diminuição do apetite e falta de ar, distúrbios
        gastrointestinais (náusea/vômito/diarreia) ou tem/teve histórico de
        internação por falência respiratória aguda ou pneumonia?
      </p>
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial12Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial12Flag)
      }}</strong
      >&nbsp;) não <br />
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      <span [hidden]="!qual"
        >Quais, há quanto tempo?
        <strong>{{ this.coletor.historiaMedicaSocial12 }}</strong></span
      >
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">Tomou alguma vacina recentemente?</p>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial13Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial13Flag)
      }}</strong
      >&nbsp;) não <br />
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      <span [hidden]="!qual"
        >Qual(is), há quanto tempo?
        <strong>{{ this.coletor.historiaMedicaSocial13 }}</strong></span
      >
    </td>
  </tr>

  <tr>
    <td>
      Já teve alguma destas doenças e/ou sintomas?
      <br />
      {{ doecasText() }}
    </td>
  </tr>
</table>

<div class="space"></div>

<table>
  <tr>
    <td class="center-bottom-title" style="height: 40px">EXAME FÍSICO</td>
  </tr>

  <tr>
    <td>
      <p class="page-paragrafo">
        Apresenta lesões de pele ou mucosas? (&nbsp;<strong>{{
          exameSim(coletor.exameFisico1Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          exameNao(coletor.exameFisico1Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Qual? <strong>{{ coletor.exameFisico1 }}</strong></span
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Apresenta cicatrizes ou incisões cirúrgicas aparentes? (&nbsp;<strong>{{
          exameSim(coletor.exameFisico2Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          exameNao(coletor.exameFisico2Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Onde? <strong>{{ coletor.exameFisico2 }}</strong></span
        >
      </p>
    </td>
  </tr>

  <tr>
    <td>
      <p class="page-paragrafo">
        Apresenta icterícia? (&nbsp;<strong>{{
          exameSim(coletor.exameFisico3Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          exameNao(coletor.exameFisico3Flag)
        }}</strong
        >&nbsp;) não
      </p>
    </td>
  </tr>

  <tr>
    <td>
      <p class="page-paragrafo">
        Apresenta hepatomegalia? (&nbsp;<strong>{{
          exameSim(coletor.exameFisico4Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          exameNao(coletor.exameFisico4Flag)
        }}</strong
        >&nbsp;) não
      </p>
    </td>
  </tr>

  <tr>
    <td>
      <p class="page-paragrafo" style="border-bottom: 0px">
        Apresenta linfadenopatia difusa? (&nbsp;<strong>{{
          exameSim(coletor.exameFisico5Flag)
        }}</strong
        >&nbsp;) sim (&nbsp;<strong>{{
          exameNao(coletor.exameFisico5Flag)
        }}</strong
        >&nbsp;) não <br /><span [hidden]="!qual"
          >Onde? <strong>{{ coletor.exameFisico5 }}</strong></span
        >
      </p>
    </td>
  </tr>
</table>

<table style="border-top: none">
  <tr>
    <td class="center-bottom-title" style="height: 40px">
      DADOS LABORATORIAIS
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Data: <strong>{{ dataExamesSanguineos }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Tipagem Sanguínea:
        <strong>
          {{ doador.tipagemSanguinea }}
        </strong>
        (O,A,B,AB) (&nbsp;<strong>{{ rhNegativo(doador.rh) }}</strong
        >&nbsp;) Rh negativo (&nbsp;<strong>{{ rhPositivo(doador.rh) }}</strong
        >&nbsp;) Rh positivo
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        (PAI) – Pesquisa de Anticorpos séricos Irregulares:
        <strong>{{ coletor.paiFlag }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Hemograma: <strong>{{ coletor.hemograma }}</strong>
      </p>
    </td>
  </tr>

  <tr style="border-bottom: none">
    <td>Resultados sorológicos</td>
  </tr>

  <tr class="dados-laboratoriais">
    <td><br /></td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      - Trypanosoma cruzi (Chagas) - IgG:
      <strong> {{ coletor.trypanosoma_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Trypanosoma cruzi (Chagas) - IgM:
      <strong> {{ coletor.trypanosoma_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Citomegalovirus - IgG:
      <strong>{{ coletor.citomegalovirus_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Citomegalovirus - IgM:
      <strong>{{ coletor.citomegalovirus_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - HIV Total (HIV I e HIV II):
      <strong>{{ coletor.hiv_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - HIV - Antígeno P24 - PESQUISA E/OU DOSAGEM:
      <strong>{{ coletor.hiv_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - HTLV I e II:
      <strong>{{ coletor.htlv }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Hepatite B - HBsAg:
      <strong>{{ coletor.hepatiteB_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Hepatite B - HBcAc-IgG:
      <strong>{{ coletor.hepatiteB_3 }}</strong>
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      - Hepatite B - HBcAc-IgM:
      <strong>{{ coletor.hepatiteB_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Hepatite B - HBsAc (anti-HBs):
      <strong>{{ coletor.hepatiteB_4 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Hepatite C - Anti - HCV:
      <strong>{{ coletor.hepatiteC_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Hepatite C - Anti - HCV:
      <strong>{{ coletor.hepatiteC_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Treponema pallidum (sífilis) - FTA-ABS-IgG:
      <strong>{{ coletor.treponemaPallidum_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Treponema pallidum (sífilis) - FTA-ABS-IgM:
      <strong>{{ coletor.treponemaPallidum_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Sífilis - VDRL:
      <strong>{{ coletor.sifilisvdrl }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Toxoplasma gondii (toxoplasmose) - IgG:
      <strong>{{ coletor.toxoplasmaGondii_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Toxoplasma gondii (toxoplasmose) - IgM:
      <strong>{{ coletor.toxoplasmaGondii_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Malária - IgG:
      <strong>{{ coletor.malaria_1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Malária - IgM:
      <strong>{{ coletor.malaria_2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Sorologia para SARS-CoV2/Covid-19 (IgG):
      <strong>{{ coletor.sARS_CoV2_Covid_19_igg }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Sorologia para SARS-CoV2/Covid-19 (IgM):
      <strong>{{ coletor.sARS_CoV2_Covid_19_igm }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - SARS-CoV2/Covid-19 (PCR):
      <strong>{{ coletor.sARS_CoV2_Covid_pcr }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR Qualitativo para CMV:
      <strong>{{ coletor.pcrqualitativocmv }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR Quantitativo para Hepatite B:
      <strong>{{ coletor.pcrquantitativohepatiteb }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR Qualitativo para Hepatite C:
      <strong>{{ coletor.pcrqualitativohepatitec }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR Qualitativo para HIV:
      <strong>{{ coletor.pcrqualitativohiv }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR para HTLV I:
      <strong>{{ coletor.pcrhtlv1 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR para HTLV II:
      <strong>{{ coletor.pcrhtlv2 }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - PCR Qualitativo para Epstein Barr:
      <strong>{{ coletor.pcrqualitativoepsteinbarr }}</strong>
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      - Solicitados exames adicionais:
      <strong>{{ coletor.examesadicionais }}</strong>
    </td>
  </tr>
</table>

<div class="space"></div>

<table>
  <tr>
    <th class="center-bottom-title" style="height: 40px">
      DESCRIÇÃO DO PROCEDIMENTO DE COLETA
    </th>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Responsável pela coleta: <strong>{{ responsavelColeta }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Material Coletado (ex: polpa...): <strong>{{ tecidosNome() }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Sítio de Coleta (dente, região...):
        <strong>{{ tecidosSitio() }}</strong>
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Data:
        <strong>{{ dataColeta }}</strong>
        <span style="margin-left: 120px">Hora de começo e fim da coleta: </span>
        <strong
          >{{ coletor.inicioProcedimento }} /
          {{ coletor.fimProcedimento }}</strong
        >
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Tempo e temperatura da geladeira em que o material biológico foi
        armazenado previamente ao acondicionamento na Medical Box
        _____h:_______min ________°C
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p class="page-paragrafo">
        Transportadora: <strong>{{ coletor.transportadora }}</strong>
      </p>
    </td>
  </tr>
  <tr style="border-bottom: none">
    <td>DESCRIÇÃO DO PROCEDIMENTO DE COLETA</td>
  </tr>

  <tr class="dados-laboratoriais">
    <td><br /></td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Realizou profilaxia? (&nbsp;
      <strong>
        {{ exameNao(coletor.profilaxia) }}
      </strong>
      &nbsp;) Não; (&nbsp;
      <strong>
        {{ exameSim(coletor.profilaxia) }}
      </strong>
      &nbsp;) Sim. Qual produto usou: pedra pomes (&nbsp;
      <strong>{{ check(coletor.pedraPomes) }}</strong
      >&nbsp;); pasta profilática (&nbsp;
      <strong> {{ check(coletor.pastaPolifatica) }} </strong>&nbsp;); outro
      (&nbsp;<strong>{{ check(coletor.outroProfilaxiaCheck) }}</strong
      >&nbsp;) qual <strong>{{ coletor.outroProfilaxia }}</strong>
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Realizou bochechos? (&nbsp;<strong>{{
        exameNao(coletor.bochechos)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.bochechos) }}</strong
      >&nbsp;) Sim. Qual produto usou: Clorexidina (&nbsp;<strong>{{
        check(coletor.clorexidina)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.clorexidinaPorcentagem }}%</strong
      >&nbsp;); Perborato de Sódio (BlueM) (&nbsp;<strong>{{
        check(coletor.perboratoDeSodioBlueM)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.perboratoSodioPorcentagem }}%</strong
      >&nbsp;); Peróxido de hidrogênio (&nbsp;<strong>{{
        check(coletor.peroxidoDeHidrogenio)
      }}</strong
      >&nbsp;) (&nbsp;<strong
        >{{ coletor.peroxidoHidrogenioPorcentagem }}%</strong
      >&nbsp;) Cetilperidínio (&nbsp;<strong>{{
        check(coletor.cetilperidinio)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.cetilperidinioPorcentagem }}%</strong
      >&nbsp;)&nbsp; Outros (&nbsp;<strong>{{
        check(coletor.outrosBochechoCheck)
      }}</strong
      >&nbsp;)&nbsp;Qual: {{ coletor.outroBochechos }} (&nbsp;<strong
        >{{ coletor.outroBochechoPorcentagem }}%</strong
      >&nbsp;)
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Procedimento anestésico: Usou anestésico tópico? (&nbsp;<strong>{{
        exameNao(coletor.anestesicoTopico)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.anestesicoTopico)
      }}</strong
      >&nbsp;) Sim. Qual: Benzocaína (&nbsp;<strong>{{
        check(coletor.benzocaina)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.benzocainaPorcentagem }}%</strong
      >&nbsp;); Tetracaína (&nbsp;<strong>{{
        check(coletor.tetracaina)
      }}</strong
      >&nbsp;) ( &nbsp;<strong>{{ coletor.tetracainaPorcentagem }}%</strong
      >&nbsp;) ; Xilocaína (&nbsp;<strong>{{ check(coletor.xilocaina) }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.xilocainaPorcentagem }}%</strong
      >&nbsp;); outros (&nbsp;<strong>{{
        check(coletor.outrosAnestesicoTopicoCheck)
      }}</strong
      >&nbsp;) Qual: {{ coletor.outroAnestesicoTopico }} (&nbsp;<strong
        >{{ coletor.outroAnestesicoTPorcentagem }}%</strong
      >&nbsp;)
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Usou anestésico Injetável? (&nbsp;<strong>{{
        exameNao(coletor.anestesicoInjetavel)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.anestesicoInjetavel)
      }}</strong
      >&nbsp;) Sim. Qual: (&nbsp;<strong>{{
        check(coletor.mepivacaina)
      }}</strong
      >&nbsp;) mepivacaína (&nbsp;&nbsp;) (&nbsp;<strong
        >{{ coletor.mepivacainaPorcentagem }}%</strong
      >&nbsp;); prilocaína (&nbsp;<strong>{{
        check(coletor.prilocaina)
      }}</strong
      >&nbsp;) ( &nbsp;<strong>{{ coletor.prilocainaPorcentagem }}%</strong
      >&nbsp;); articaína (&nbsp;<strong>{{ check(coletor.articaina) }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.articainaPorcentagem }}%</strong
      >&nbsp;); citocaína (&nbsp;<strong>{{ check(coletor.citocaina) }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.citocainaPorcentagem }}%</strong
      >&nbsp;); Lidocaína (&nbsp;<strong>{{ check(coletor.lidocaina) }}</strong
      >&nbsp;) ( &nbsp;<strong>{{ coletor.lidocainaPorcentagem }}%</strong
      >&nbsp;); outros (&nbsp;<strong>{{
        check(coletor.outrosAnestesicoInjetavelCheck)
      }}</strong
      >&nbsp;) Qual {{ coletor.outroAnestesicoInjetavel }} (&nbsp;<strong
        >{{ coletor.outroAnestesicoIPorcentagem }}%</strong
      >&nbsp;)
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Anestésico com vaso constritor: (&nbsp;<strong>{{
        exameNao(coletor.anestesicoVasoConstritor)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.anestesicoVasoConstritor)
      }}</strong
      >&nbsp;) Sim. Qual: Adrenalina (&nbsp;<strong>{{
        check(coletor.adrenalina)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.adrenalinaPorcentagem }}%</strong
      >&nbsp;); Noradrenalina (&nbsp;<strong
        >{{ coletor.noradrenalinaPorcentagem }}%</strong
      >&nbsp;); Cloridrato de fenilefrina (&nbsp;<strong>{{
        check(coletor.cloridratoDeFenilefrina)
      }}</strong
      >&nbsp;) (&nbsp;<strong
        >{{ coletor.cloridratoFenilefrinaPorcentagem }}%</strong
      >&nbsp;); Outros (&nbsp;<strong>{{
        check(coletor.porcentagemOutrosAnestesicoVasoConstritor)
      }}</strong
      >&nbsp;) Qual:
      {{ coletor.outrosAnestesicoVasoConstritorDesc }} (&nbsp;<strong
        >{{ coletor.porcentagemOutrosAnestesicoVasoConstritor }}%</strong
      >&nbsp;);
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Realizou fenda para clivagem? (&nbsp;<strong>{{
        exameNao(coletor.clivagem)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.clivagem) }}</strong
      >&nbsp;) Sim. Onde: (&nbsp;<strong>{{
        check(coletor.vestibuloLingual)
      }}</strong
      >&nbsp;) Vestibulo-lingual; (&nbsp;<strong>{{
        check(coletor.mesioDistal)
      }}</strong
      >&nbsp;) Mesio-distal; (&nbsp;<strong>{{
        check(coletor.amelocemataria)
      }}</strong
      >&nbsp;) Amelocementária.
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Realizou odontosecção para remoção do elemento dentário? (&nbsp;<strong>{{
        exameNao(coletor.odontoseccao)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.odontoseccao) }}</strong
      >&nbsp;) Sim; Qual elemento? (&nbsp;<strong>{{
        coletor.desc_Odontoseccao
      }}</strong
      >&nbsp;)
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Realizou remoção prévia de restaurações? (&nbsp;<strong>{{
        exameNao(coletor.remocaoRestauracoes)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.remocaoRestauracoes)
      }}</strong
      >&nbsp;) Sim. Qual elemento? (&nbsp;<strong>{{
        coletor.desc_RemocaoRestauracoes
      }}</strong
      >&nbsp;)
    </td>
  </tr>

  <tr class="dados-laboratoriais">
    <td>
      Realizou remoção prévia de cáries? (&nbsp;<strong>{{
        exameNao(coletor.remocaoCaries)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.remocaoCaries) }}</strong
      >&nbsp;) Sim. Qual elemento? (&nbsp;<strong>{{
        coletor.desc_RemocaoCaries
      }}</strong
      >&nbsp;)
    </td>
  </tr>
  <tr class="dados-laboratoriais">
    <td>
      Mais alguma informação relevante em relação ao procedimento de coleta?
      <div style="height: 5px"></div>
    </td>
  </tr>
</table>

<div class="space"></div>

<table style="border: none; width: 100%">
  <tr style="border: none">
    <td>
      <div>
        __________________________________
        <br />
        <span>ASSINATURA CREDENCIADO</span>
      </div>
    </td>
  </tr>
</table> -->

<div>
  <p [hidden]="fichaValida" class="invalid invalid-ficha">RASCUNHO</p>
  <!-- <img
    src="data:image/png;base64,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"
  /> -->
  <div class="div-ficha" style="margin-top: 15px">
    <p class="page-paragrafo">
      <strong>Título:</strong> FICHA DE TRIAGEM CLÍNICA PARA COLETA DE MATERIAL
      BIOLÓGICO
    </p>
    <p class="page-paragrafo">
      Nome do Paciente: <strong>{{ doador.nome }}</strong>
    </p>
    <p class="page-paragrafo">
      <span>Data nascimento: </span>
      <strong>{{ dataNascimentoDoador }}</strong>
      <span style="padding-left: 270px">CPF: </span>
      <strong>{{ doador.cpf }}</strong>
    </p>
    <p class="page-paragrafo">
      Endereço: <strong>{{ doador.endereco }} </strong>, n°
      <strong>{{ doador.numEndereco }}</strong>
    </p>
    <p class="page-paragrafo">
      <span>CEP: </span> <strong>{{ doador.cep }}</strong>
      <span style="padding-left: 350px">Cidade: </span>
      <strong>{{ doador.cidade }}</strong>
    </p>
    <p class="page-paragrafo" style="border-bottom: 0px">
      Sexo (&nbsp;<strong>{{ sexoFeminino(doador.sexo) }}</strong
      >&nbsp;) Feminino
      <span
        >(&nbsp;<strong>{{ sexoMasculino(doador.sexo) }}</strong
        >&nbsp;) Masculino
      </span>
      <span
        >(&nbsp;<strong>{{ sexoOutro(doador.sexo) }}</strong
        >&nbsp;) Outro
      </span>
    </p>
  </div>

  <br />

  <div class="div-ficha">
    <h1
      class="page-title"
      style="border-bottom: 1px solid; padding-bottom: 3px"
    >
      HISTÓRICO DE SAÚDE
    </h1>
    <p class="page-paragrafo">
      Está fazendo algum tratamento médico? (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial1Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(this.coletor.historiaMedicaSocial1Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial1 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Faz uso de algum medicamento? (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial2Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial2Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual(is) medicamento(s)?
        <strong>{{ this.coletor.historiaMedicaSocial2 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Possui algum tipo de alergia? (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial3Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial3Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual">Qual? </span>
      <strong [hidden]="!qual">{{ this.coletor.historiaMedicaSocial3 }}</strong>
    </p>

    <p class="page-paragrafo">
      Faz algum tratamento complementar (fitoterápico, homeopático...)? <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial4Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial4Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual">Qual? </span>
      <strong [hidden]="!qual">{{ this.coletor.historiaMedicaSocial4 }}</strong>
    </p>

    <p class="page-paragrafo">
      Já realizou alguma intervenção cirúrgica?<br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial5Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial5Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial5 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Já recebeu transfusão de hemocomponentes ou fez uso de algum
      hemoderivado?<br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial6Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial6Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial6 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Já realizou algum transplante de células, tecidos ou órgãos ou
      xenotransplante (osso bovino, por exemplo)? <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial7Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial7Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial7 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Possui alguma doença hereditária, hematológica ou imunológica? <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial8Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial8Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial8 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Já teve algum tipo de doença maligna? (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial9Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial9Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ this.coletor.historiaMedicaSocial9 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Fez viagem recente e/ou teve exposição a agentes infecciosos? <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial10Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial10Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Onde, qual, há quanto tempo?
        <strong>{{ this.coletor.historiaMedicaSocial10 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Teve contato com alguém confirmado ou suspeito de covid-19? <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial11Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial11Flag)
      }}</strong
      >&nbsp;) não <br />
    </p>

    <p class="page-paragrafo">
      Está ou teve algum destes sintomas: Febre, tosse, coriza, dor de garganta,
      dificuldade para respirar, perda de olfato, alteração do paladar, cansaço,
      diminuição do apetite e falta de ar, distúrbios gastrointestinais
      (náusea/vômito/diarreia) ou tem/teve histórico de internação por falência
      respiratória aguda ou pneumonia?
      <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial12Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial12Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Quais, há quanto tempo?
        <strong>{{ this.coletor.historiaMedicaSocial12 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Tomou alguma vacina recentemente? <br />
      (&nbsp;<strong>{{
        opcaoSim(this.coletor.historiaMedicaSocial13Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        opcaoNao(coletor.historiaMedicaSocial13Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual(is), há quanto tempo?
        <strong>{{ this.coletor.historiaMedicaSocial13 }}</strong></span
      >
    </p>

    <p class="page-paragrafo" style="border-bottom: 0px">
      Já teve alguma destas doenças e/ou sintomas?
      <br />

      {{ doecasText() }}
    </p>
  </div>

  <br />
</div>

<div>
  <p [hidden]="fichaValida" class="invalid invalid-ficha">RASCUNHO</p>
  <!-- <img
    src="data:image/png;base64,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"
  /> -->

  <div class="div-ficha">
    <h1
      class="page-title"
      style="border-bottom: 1px solid; padding-bottom: 3px"
    >
      EXAME FÍSICO
    </h1>

    <p class="page-paragrafo">
      Apresenta lesões de pele ou mucosas? (&nbsp;<strong>{{
        exameSim(coletor.exameFisico1Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        exameNao(coletor.exameFisico1Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Qual? <strong>{{ coletor.exameFisico1 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Apresenta cicatrizes ou incisões cirúrgicas aparentes? (&nbsp;<strong>{{
        exameSim(coletor.exameFisico2Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        exameNao(coletor.exameFisico2Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Onde? <strong>{{ coletor.exameFisico2 }}</strong></span
      >
    </p>

    <p class="page-paragrafo">
      Apresenta icterícia? (&nbsp;<strong>{{
        exameSim(coletor.exameFisico3Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        exameNao(coletor.exameFisico3Flag)
      }}</strong
      >&nbsp;) não
    </p>

    <p class="page-paragrafo">
      Apresenta hepatomegalia? (&nbsp;<strong>{{
        exameSim(coletor.exameFisico4Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        exameNao(coletor.exameFisico4Flag)
      }}</strong
      >&nbsp;) não
    </p>

    <p class="page-paragrafo" style="border-bottom: 0px">
      Apresenta linfadenopatia difusa? (&nbsp;<strong>{{
        exameSim(coletor.exameFisico5Flag)
      }}</strong
      >&nbsp;) sim (&nbsp;<strong>{{
        exameNao(coletor.exameFisico5Flag)
      }}</strong
      >&nbsp;) não <br /><span [hidden]="!qual"
        >Onde? <strong>{{ coletor.exameFisico5 }}</strong></span
      >
    </p>
  </div>

  <div class="div-ficha">
    <h1
      class="page-title"
      style="border-bottom: 1px solid; padding-bottom: 3px"
    >
      DADOS LABORATORIAIS
    </h1>

    <p class="page-paragrafo">
      Data: <strong>{{ dataExamesSanguineos }}</strong>
    </p>
    <p class="page-paragrafo">
      Tipagem Sanguínea:
      <strong>
        {{ doador.tipagemSanguinea }}
      </strong>
      (O,A,B,AB) (&nbsp;<strong>{{ rhNegativo(doador.rh) }}</strong
      >&nbsp;) Rh negativo (&nbsp;<strong>{{ rhPositivo(doador.rh) }}</strong
      >&nbsp;) Rh positivo
    </p>
    <p class="page-paragrafo">
      (PAI) – Pesquisa de Anticorpos séricos Irregulares:
      <strong>{{ coletor.paiFlag }}</strong>
    </p>
    <p class="page-paragrafo">
      Hemograma: <strong>{{ coletor.hemograma }}</strong>
    </p>

    <p class="page-paragrafo" style="border-bottom: 0px">
      Resultados sorológicos
      <br />
      <br />

      <span>
        - Trypanosoma cruzi (Chagas) - IgG:
        <strong> {{ coletor.trypanosoma_1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Trypanosoma cruzi (Chagas) - IgM:
        <strong> {{ coletor.trypanosoma_2 }}</strong>
      </span>

      <br />

      <span>
        - Citomegalovirus - IgG:
        <strong>{{ coletor.citomegalovirus_1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Citomegalovirus - IgM:
        <strong>{{ coletor.citomegalovirus_2 }}</strong></span
      >

      <br />

      <span>
        - HIV Total (HIV I e HIV II):
        <strong>{{ coletor.hiv_1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - HIV - Antígeno P24 - PESQUISA E/OU DOSAGEM:
        <strong>{{ coletor.hiv_2 }}</strong>
      </span>

      <br />

      <span>
        - HTLV I e II:
        <strong>{{ coletor.htlv }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Hepatite B - HBsAg:
        <strong>{{ coletor.hepatiteB_1 }}</strong>
      </span>

      <br />

      <span>
        - Hepatite B - HBcAc-IgG:
        <strong>{{ coletor.hepatiteB_3 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Hepatite B - HBcAc-IgM:
        <strong>{{ coletor.hepatiteB_2 }}</strong>
      </span>

      <br />

      <span>
        - Hepatite B - HBsAc (anti-HBs):
        <strong>{{ coletor.hepatiteB_4 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Hepatite C - Anti - HCV:
        <strong>{{ coletor.hepatiteC_1 }}</strong>
      </span>

      <br />

      <span>
        - Treponema pallidum (sífilis) - FTA-ABS-IgG:
        <strong>{{ coletor.treponemaPallidum_1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Treponema pallidum (sífilis) - FTA-ABS-IgM:
        <strong>{{ coletor.treponemaPallidum_2 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Sífilis - VDRL:
        <strong>{{ coletor.sifilisvdrl }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Toxoplasma gondii (toxoplasmose) - IgG:
        <strong>{{ coletor.toxoplasmaGondii_1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Toxoplasma gondii (toxoplasmose) - IgM:
        <strong>{{ coletor.toxoplasmaGondii_2 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Malária - IgG:
        <strong>{{ coletor.malaria_1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Malária - IgM:
        <strong>{{ coletor.malaria_2 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Sorologia para SARS-CoV2/Covid-19 (IgG):
        <strong>{{ coletor.sARS_CoV2_Covid_19_igg }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Sorologia para SARS-CoV2/Covid-19 (IgM):
        <strong>{{ coletor.sARS_CoV2_Covid_19_igm }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - SARS-CoV2/Covid-19 (PCR):
        <strong>{{ coletor.sARS_CoV2_Covid_pcr }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR Qualitativo para CMV:
        <strong>{{ coletor.pcrqualitativocmv }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR Quantitativo para Hepatite B:
        <strong>{{ coletor.pcrquantitativohepatiteb }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR Qualitativo para Hepatite C:
        <strong>{{ coletor.pcrqualitativohepatitec }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR Qualitativo para HIV:
        <strong>{{ coletor.pcrqualitativohiv }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR para HTLV I:
        <strong>{{ coletor.pcrhtlv1 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR para HTLV II:
        <strong>{{ coletor.pcrhtlv2 }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - PCR Qualitativo para Epstein Barr:
        <strong>{{ coletor.pcrqualitativoepsteinbarr }}</strong>
      </span>

      <br />

      <span style="padding-left: 0px">
        - Solicitados exames adicionais:
        <strong>{{ coletor.examesadicionais }}</strong>
      </span>
    </p>
  </div>
  <br />
  <p [hidden]="fichaValida" class="invalid invalid-ficha">RASCUNHO</p>
  <!-- <img
    src="data:image/png;base64,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"
  /> -->
  <div class="div-ficha">
    <h1
      class="page-title"
      style="border-bottom: 1px solid; padding-bottom: 3px"
    >
      DESCRIÇÃO DO PROCEDIMENTO DE COLETA
    </h1>

    <p class="page-paragrafo">
      Responsável pela coleta: <strong>{{ responsavelColeta }}</strong>
    </p>
    <p class="page-paragrafo">
      Material Coletado (ex: polpa...): <strong>{{ tecidosNome() }}</strong>
    </p>
    <p class="page-paragrafo">
      Sítio de Coleta (dente, região...):
      <strong>{{ tecidosSitio() }}</strong>
    </p>
    <p class="page-paragrafo">
      Data:
      <strong>{{ dataColeta }}</strong>
      <span style="margin-left: 120px">Hora de começo e fim da coleta: </span>
      <strong
        >{{ coletor.inicioProcedimento }} /
        {{ coletor.fimProcedimento }}</strong
      >
    </p>
    <p class="page-paragrafo">
      Tempo e temperatura da geladeira em que o material biológico foi
      armazenado previamente ao acondicionamento na Medical Box
      _____h:_______min ________°C
    </p>
    <p class="page-paragrafo">
      Transportadora: <strong>{{ coletor.transportadora }}</strong>
    </p>
    <p class="page-paragrafo" style="border-bottom: 0px">
      Descrição do Transoperatório<br />
      <br />
      Realizou profilaxia? (&nbsp;<strong>{{
        exameNao(coletor.profilaxia)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.profilaxia) }}</strong
      >&nbsp;) Sim. Qual produto usou: pedra pomes (&nbsp;<strong>{{
        check(coletor.pedraPomes)
      }}</strong
      >&nbsp;); pasta profilática (&nbsp;<strong>{{
        check(coletor.pastaPolifatica)
      }}</strong
      >&nbsp;); outro (&nbsp;<strong>{{
        check(coletor.outroProfilaxiaCheck)
      }}</strong
      >&nbsp;) qual <strong>{{ coletor.outroProfilaxia }}</strong>

      <br />

      Realizou bochechos? (&nbsp;<strong>{{
        exameNao(coletor.bochechos)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.bochechos) }}</strong
      >&nbsp;) Sim. Qual produto usou: Clorexidina (&nbsp;<strong>{{
        check(coletor.clorexidina)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.clorexidinaPorcentagem }}%</strong
      >&nbsp;); Perborato de Sódio (BlueM) (&nbsp;<strong>{{
        check(coletor.perboratoDeSodioBlueM)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.perboratoSodioPorcentagem }}%</strong
      >&nbsp;); Peróxido de hidrogênio (&nbsp;<strong>{{
        check(coletor.peroxidoDeHidrogenio)
      }}</strong
      >&nbsp;) (&nbsp;<strong
        >{{ coletor.peroxidoHidrogenioPorcentagem }}%</strong
      >&nbsp;) Cetilperidínio (&nbsp;<strong>{{
        check(coletor.cetilperidinio)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.cetilperidinioPorcentagem }}%</strong
      >&nbsp;)&nbsp; Outros (&nbsp;<strong>{{
        check(coletor.outrosBochechoCheck)
      }}</strong
      >&nbsp;)&nbsp;Qual: {{ coletor.outroBochechos }} (&nbsp;<strong
        >{{ coletor.outroBochechoPorcentagem }}%</strong
      >&nbsp;)<br /><br />
    </p>

    <p class="page-paragrafo" style="border-bottom: 0px">
      Procedimento anestésico: Usou anestésico tópico? (&nbsp;<strong>{{
        exameNao(coletor.anestesicoTopico)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.anestesicoTopico)
      }}</strong
      >&nbsp;) Sim. Qual: Benzocaína (&nbsp;<strong>{{
        check(coletor.benzocaina)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.benzocainaPorcentagem }}%</strong
      >&nbsp;); Tetracaína (&nbsp;<strong>{{
        check(coletor.tetracaina)
      }}</strong
      >&nbsp;) ( &nbsp;<strong>{{ coletor.tetracainaPorcentagem }}%</strong
      >&nbsp;) ; Xilocaína (&nbsp;<strong>{{ check(coletor.xilocaina) }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.xilocainaPorcentagem }}%</strong
      >&nbsp;); outros (&nbsp;<strong>{{
        check(coletor.outrosAnestesicoTopicoCheck)
      }}</strong
      >&nbsp;) Qual: {{ coletor.outroAnestesicoTopico }} (&nbsp;<strong
        >{{ coletor.outroAnestesicoTPorcentagem }}%</strong
      >&nbsp;)

      <br />

      Usou anestésico Injetável? (&nbsp;<strong>{{
        exameNao(coletor.anestesicoInjetavel)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.anestesicoInjetavel)
      }}</strong
      >&nbsp;) Sim. Qual: (&nbsp;<strong>{{
        check(coletor.mepivacaina)
      }}</strong
      >&nbsp;) mepivacaína (&nbsp;&nbsp;) (&nbsp;<strong
        >{{ coletor.mepivacainaPorcentagem }}%</strong
      >&nbsp;); prilocaína (&nbsp;<strong>{{
        check(coletor.prilocaina)
      }}</strong
      >&nbsp;) ( &nbsp;<strong>{{ coletor.prilocainaPorcentagem }}%</strong
      >&nbsp;); articaína (&nbsp;<strong>{{ check(coletor.articaina) }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.articainaPorcentagem }}%</strong
      >&nbsp;); citocaína (&nbsp;<strong>{{ check(coletor.citocaina) }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.citocainaPorcentagem }}%</strong
      >&nbsp;); Lidocaína (&nbsp;<strong>{{ check(coletor.lidocaina) }}</strong
      >&nbsp;) ( &nbsp;<strong>{{ coletor.lidocainaPorcentagem }}%</strong
      >&nbsp;); outros (&nbsp;<strong>{{
        check(coletor.outrosAnestesicoInjetavelCheck)
      }}</strong
      >&nbsp;) Qual {{ coletor.outroAnestesicoInjetavel }} (&nbsp;<strong
        >{{ coletor.outroAnestesicoIPorcentagem }}%</strong
      >&nbsp;)

      <br />

      Anestésico com vaso constritor: (&nbsp;<strong>{{
        exameNao(coletor.anestesicoVasoConstritor)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.anestesicoVasoConstritor)
      }}</strong
      >&nbsp;) Sim. Qual: Adrenalina (&nbsp;<strong>{{
        check(coletor.adrenalina)
      }}</strong
      >&nbsp;) (&nbsp;<strong>{{ coletor.adrenalinaPorcentagem }}%</strong
      >&nbsp;); Noradrenalina (&nbsp;<strong
        >{{ coletor.noradrenalinaPorcentagem }}%</strong
      >&nbsp;); Cloridrato de fenilefrina (&nbsp;<strong>{{
        check(coletor.cloridratoDeFenilefrina)
      }}</strong
      >&nbsp;) (&nbsp;<strong
        >{{ coletor.cloridratoFenilefrinaPorcentagem }}%</strong
      >&nbsp;); Outros (&nbsp;<strong>{{
        check(coletor.porcentagemOutrosAnestesicoVasoConstritor)
      }}</strong
      >&nbsp;) Qual:
      {{ coletor.outrosAnestesicoVasoConstritorDesc }} (&nbsp;<strong
        >{{ coletor.porcentagemOutrosAnestesicoVasoConstritor }}%</strong
      >&nbsp;);

      <br /><br />

      Realizou fenda para clivagem? (&nbsp;<strong>{{
        exameNao(coletor.clivagem)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.clivagem) }}</strong
      >&nbsp;) Sim. Onde: (&nbsp;<strong>{{
        check(coletor.vestibuloLingual)
      }}</strong
      >&nbsp;) Vestibulo-lingual; (&nbsp;<strong>{{
        check(coletor.mesioDistal)
      }}</strong
      >&nbsp;) Mesio-distal; (&nbsp;<strong>{{
        check(coletor.amelocemataria)
      }}</strong
      >&nbsp;) Amelocementária.

      <br />

      Realizou odontosecção para remoção do elemento dentário? (&nbsp;<strong>{{
        exameNao(coletor.odontoseccao)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.odontoseccao) }}</strong
      >&nbsp;) Sim; Qual elemento? (&nbsp;<strong>{{
        coletor.desc_Odontoseccao
      }}</strong
      >&nbsp;)
      <br />
      Realizou remoção prévia de restaurações? (&nbsp;<strong>{{
        exameNao(coletor.remocaoRestauracoes)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{
        exameSim(coletor.remocaoRestauracoes)
      }}</strong
      >&nbsp;) Sim. Qual elemento? (&nbsp;<strong>{{
        coletor.desc_RemocaoRestauracoes
      }}</strong
      >&nbsp;)

      <br />

      Realizou remoção prévia de cáries? (&nbsp;<strong>{{
        exameNao(coletor.remocaoCaries)
      }}</strong
      >&nbsp;) Não; (&nbsp;<strong>{{ exameSim(coletor.remocaoCaries) }}</strong
      >&nbsp;) Sim. Qual elemento? (&nbsp;<strong>{{
        coletor.desc_RemocaoCaries
      }}</strong
      >&nbsp;)

      <br />

      Mais alguma informação relevante em relação ao procedimento de coleta?
    </p>
    <br /><br />
  </div>
</div>

<div>
  <!-- <div class="div-ficha" style="margin-top: 15px"> -->
  __________________________________
  <br />
  <span style="margin-left: 20px">ASSINATURA CREDENCIADO</span>
  <!-- </div> -->
</div>
